import { useDocument } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "../firebase/clientApp.js"; // Assicurati di avere la configurazione di Firebase
import { Box, Typography, CircularProgress } from "@mui/material";

export default function Result() {
    const [value, loading, error] = useDocument(
        doc(db, "totem-terna-7-marzo-2025", "event", "users", "lastuser"),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );

    if (loading) return <CircularProgress />;
    if (error) console.info(error);
    if (error) return <Typography color="error">Errore nel recupero dati</Typography>;

    const userData = value?.data();
    const nome = userData?.nome || "In attesa...";
    const cognome = userData?.cognome || "In attesa...";
    const score = userData?.score ?? null;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                backgroundImage:'url("/images/monitor-bkg.png")',
                backgroundSize:'cover',
                padding:'32px'
            }}
        >
            <Typography variant="h2" mt={10} textAlign={'center'} fontWeight={'bold'}>
                ESITO DEL QUIZ
            </Typography>
            <Typography variant="h3" gutterBottom textAlign={'center'}>
                Ciao <span style={{fontWeight:'bold', color:'#4fadff'}}>{nome}</span>, con le tue risposte hai guadagnato la
            </Typography>
            {score !== null ? (
                <>
                    <Typography variant="h1" mt={10} color="#4fadff" fontWeight={'bold'}>
                        {score >= 9 ? "MEDAGLIA D'ORO" : score >= 7 ? "MEDAGLIA D'ARGENTO" : score >= 5 ? "MEDAGLIA DI BRONZO" : "MEDAGLIA DI LEGNO"}
                    </Typography>
                    <Typography variant="h2" mt={2} color="#fff" fontWeight={'normal'}>
                        {score >= 9 ? "da 9 a 10 corrette" : score >= 7 ? "da 7 a 8 corrette" : score >= 5 ? "da 5 a 6 corrette" : "meno di 5 corrette"}
                    </Typography>
                    <img
                        style={{marginTop:'5%'}}
                        src={score >= 9 ? "/icons/oro.png" : score >= 7 ? "/icons/argento.png" : score >= 5 ? "/icons/bronzo.png" : "/icons/legno.png"}
                    />
                </>

            ) : (
                <Typography variant="h6" color="textSecondary">
                    In attesa del completamento del quiz...
                </Typography>
            )}
        </Box>
    );
}
